import React, { useState, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PostsPageGrid } from "./PostsPageGrid";
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig";
import { deleteAccount } from "../Service/moderationApi";
import Modal from 'react-bootstrap/Modal';
import { EditProfile, EditDp, DisplayBio, MyProjects, } from "../Components";
import { MdOutlineModeEditOutline, MdVerified, MdOutlineVerified } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { hasPermission, canRevealMobileNumber } from "../Utils/permissionUtils";
import { isDialableMobileNumber, isProbablyMaskedMobileNumber } from "../Utils/mobileNumber";
import { View24Crafts, ProfileShortlist, ProfileFollows, PaymentHistory, ProfileVerification, ProfileAuditions, ProfileRequirement } from ".";
import { ProfileConsent } from "./ProfileConsent";
const ProfilePage = () => {
    let { id } = useParams();
    let hcc_id = id
    let can_edit_profile = true
    const [EditProfileFor, setEditProfileFor] = useState("profile");
    const [EditProfileShow, setEditProfileShow] = useState(false);
    const handleEditProfileClose = () => setEditProfileShow(false);
    const [loading, setLoading] = useState(false)
    const [ProfileData, SetProfileData] = useState(null)
    const [profileUnavailable, setProfileUnavailable] = useState(false)
    const navigate = useNavigate();
    const [showRevealMobileModal, setShowRevealMobileModal] = useState(false);
    const [revealReason, setRevealReason] = useState("");
    const [revealError, setRevealError] = useState("");
    const [revealingMobile, setRevealingMobile] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteReason, setDeleteReason] = useState("");
    const [deleteError, setDeleteError] = useState("");
    const [deletingAccount, setDeletingAccount] = useState(false);
    const handleShowMessages = () => {
        navigate(`/messages/${ProfileData.hcc_id}`);
    };

    function handleLoginEvent() {
        setEditProfileShow(false);
        GetData()
    }
    const GetData = async (opts = {}) => {
        setLoading(true)
        try {
            const params = { hcc_id: id };
            if (opts?.reveal_mobile_number) params.reveal_mobile_number = 1;
            if (opts?.reveal_reason) params.reveal_reason = opts.reveal_reason;

            const responce = await axiosConfig.get(`/accounts/user-profiles/`, { params })
            const profile = responce.data.results?.[0]
            const unavailable = !profile?.id ||
                profile.is_deleted ||
                profile.is_suspended ||
                profile.is_restricted_user;

            SetProfileData(profile || null)
            setProfileUnavailable(unavailable)
            hcc_id = id
        }
        catch (error) {
            console.log(error)
            SetProfileData(null)
            setProfileUnavailable(true)
        } finally {
            setLoading(false)
        }
    }
    const [activeTab, setActiveTab] = useState(0);
    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const calculateAge = (dob) => {
        const dobDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - dobDate.getFullYear();
        const monthDiff = today.getMonth() - dobDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
            age--;
        }
        return age;
    };
    const [userPlan, setUserPlan] = useState(null);
    const fetchUserPlan = async () => {
        if (!ProfileData?.id) return;
        try {
            const response = await axiosConfig.get(`/accounts/user-plans/?profile=${ProfileData.id}`);
            setUserPlan(response.data.results[0]);
        } catch (error) {
            console.error("Error fetching user plans:", error);
        }
    };
    useEffect(() => {
        GetData();
    }, [id])
    useEffect(() => {
        if (ProfileData?.id && !profileUnavailable) {
            fetchUserPlan();
        }
    }, [ProfileData?.id, profileUnavailable]);

    const confirmDeleteAccount = async () => {
        const reason = (deleteReason || "").trim();
        if (!reason) {
            setDeleteError("Reason is required to delete an account.");
            return;
        }
        if (!ProfileData?.id) return;
        setDeletingAccount(true);
        setDeleteError("");
        try {
            await deleteAccount(ProfileData.id, reason);
            setShowDeleteModal(false);
            setDeleteReason("");
            await GetData();
        } catch (error) {
            setDeleteError(
                error?.response?.data?.detail ||
                error?.response?.data?.reason?.[0] ||
                "Failed to delete account."
            );
        } finally {
            setDeletingAccount(false);
        }
    };

    console.log(userPlan)

    const hasProfile = Boolean(ProfileData?.id) && !profileUnavailable;

    return (
        <>

            <div className="main-container">
                <div className="content-area">
                    {loading ? (
                        <div className="loader-container">
                            <img src={require('./images/loader.gif')} alt="Loading..." />
                        </div>
                    ) : !hasProfile ? (
                        <div className="profile-unavailable">
                            <h4>Profile unavailable</h4>
                            <p>
                                This profile is not available. It may have been suspended, deleted, or restricted.
                            </p>
                            {id ? (
                                <p className="text-muted small mb-3">HCC ID: {id}</p>
                            ) : null}
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => navigate("/dashboard/users")}
                            >
                                Back to Users
                            </button>
                        </div>
                    ) : (
                        <div>
                            <div className="profile-header">
                                <div className="row">
                                    <div className="col-md-4">
                                        {can_edit_profile ?
                                            <div className="editabledp">
                                                <img src={ProfileData?.profile_pic} className="dp" />
                                                <div class="middle">
                                                    <div class="text" onClick={() => {
                                                        setEditProfileShow(true);
                                                        setEditProfileFor("dp");
                                                    }}>
                                                        <MdOutlineModeEditOutline size={30} />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <img src={ProfileData.profile_pic} className="dp" />
                                        }
                                    </div>
                                    <div className="col-md-8">
                                        <div className="profile-info">
                                            <p>{ProfileData.full_name} {ProfileData.is_celebrity ? <MdVerified size={15} color="#019bf9" /> : ProfileData.is_verified && <MdOutlineVerified size={15} color="#808080" />} {can_edit_profile && <button className="btn btn-default" onClick={() => {
                                                setEditProfileShow(true);
                                                setEditProfileFor("profile");
                                            }} ><MdOutlineModeEditOutline /></button>} </p>
                                            <button className="btn btn-default btn-follow">Follow</button>
                                            {hasPermission("messagesapp.view_message") && <button className="btn btn-default btn-message" onClick={handleShowMessages}>Messages</button>}
                                            {hasPermission("accounts.view_profile") && !ProfileData.is_deleted && (
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm ms-2"
                                                    onClick={() => {
                                                        setDeleteReason("");
                                                        setDeleteError("");
                                                        setShowDeleteModal(true);
                                                    }}
                                                >
                                                    Delete account
                                                </button>
                                            )}
                                            {ProfileData.is_deleted ? (
                                                <span className="badge bg-secondary ms-2">Deleted</span>
                                            ) : ProfileData.is_suspended ? (
                                                <span className="badge bg-warning text-dark ms-2">Suspended</span>
                                            ) : null}
                                        </div>
                                        <div className="followers-info">
                                            <p>{ProfileData.designation}</p>
                                            <p><b>{ProfileData.total_posts}</b> Gallery</p>
                                            <p><b>{ProfileData.followers}</b> Followers</p>
                                        </div>
                                        <div className="details">
                                            <table className="table table-bordered">
                                                <tr>
                                                    <th>HCCID</th>
                                                    <td>{ProfileData.hcc_id}</td>
                                                    <th>Full Name</th>
                                                    <td>{ProfileData.full_name} {ProfileData.is_celebrity ? <MdVerified size={12} color="#019bf9" /> : ProfileData.is_verified && <MdOutlineVerified size={12} color="#808080" />}</td>
                                                </tr>
                                                <tr>
                                                    <th>Mobile</th>
                                                    <td>
                                                        {isDialableMobileNumber(ProfileData.mobile_number) ? (
                                                            <a href={`tel:${ProfileData.mobile_number}`}>{ProfileData.mobile_number}</a>
                                                        ) : (
                                                            <span>{ProfileData.mobile_number || "--"}</span>
                                                        )}
                                                        {canRevealMobileNumber() && isProbablyMaskedMobileNumber(ProfileData.mobile_number) && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-primary ms-2"
                                                                onClick={() => {
                                                                    setRevealError("");
                                                                    setRevealReason("");
                                                                    setShowRevealMobileModal(true);
                                                                }}
                                                            >
                                                                Show number
                                                            </button>
                                                        )}
                                                    </td>
                                                    <th>Email</th>
                                                    <td>{ProfileData.user && ProfileData.user.email}</td>
                                                </tr>
                                                <tr>
                                                    <th>Gender</th>
                                                    <td>{ProfileData.gender}</td>
                                                    <th>Profession</th>
                                                    <td>{ProfileData.profession}</td>
                                                </tr>
                                                <tr>
                                                    <th>Dob</th>
                                                    <td>
                                                        {ProfileData.dob &&
                                                            <>
                                                                {ProfileData.dob} ({calculateAge(ProfileData.dob)} years)
                                                            </>
                                                        }
                                                    </td>
                                                    <th>Roles</th>
                                                    <td>
                                                        {
                                                            ProfileData.roles && ProfileData.roles.map((role, i) => {
                                                                return (
                                                                    <>{role.role_name}, </>
                                                                )
                                                            })
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Feedback</th>
                                                    <td>{ProfileData.feedback}</td>
                                                    <th>Pro Validity</th>
                                                    <td>
                                                        {userPlan?.end_date ? (
                                                            <>
                                                                {userPlan.start_date && new Date(userPlan.start_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                                                -
                                                                {userPlan.end_date && new Date(userPlan.end_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                                                ({Math.floor((new Date(userPlan.end_date) - new Date()) / (1000 * 60 * 60 * 24))} days left)
                                                            </>
                                                        ) : (
                                                            "--"
                                                        )}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {ProfileData?.hcc_id ?
                                <>
                                    <div className="profile-tablinks">
                                        <ul className="nav custom-nav-tabs">
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(0)}
                                                >
                                                    GALLERY
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(1)}
                                                >
                                                    ABOUT
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(2)}
                                                >
                                                    PROJECTS
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 3 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(3)}
                                                >
                                                    24 Crafts
                                                </button>
                                            </li>
                                            {ProfileData?.designation?.split(',')?.some(role =>
                                                ["Executive Producer", "Casting Director", "Producer", "Director", "Associate Director", "Co-Director", "Assistant Director", "Production Manager"].includes(role.trim())
                                            ) && (
                                                    <li className="nav-item">
                                                        <button
                                                            className={`nav-link ${activeTab === 4 ? 'active' : ''}`}
                                                            onClick={() => handleTabClick(4)}
                                                        >
                                                            Auditions
                                                        </button>
                                                    </li>
                                                )}
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 5 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(5)}
                                                >
                                                    Verification
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 6 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(6)}
                                                >
                                                    Payment History
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 7 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(7)}
                                                >
                                                    Shortlists
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 8 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(8)}
                                                >
                                                    Follows
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 9 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(9)}
                                                >
                                                    Requirements
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 10 ? 'active' : ''}`}
                                                    onClick={() => handleTabClick(10)}
                                                >
                                                    Consent
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="tab-content">
                                        <div className={`tab-pane fade ${activeTab === 0 ? 'show active' : ''}`}>
                                            <div className="posting-container">
                                                <PostsPageGrid profile_id={ProfileData.id} />
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 1 ? 'show active' : ''}`}>
                                            {activeTab === 1 &&
                                                <div className="display-bio">
                                                    <DisplayBio ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                </div>
                                            }
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 2 ? 'show active' : ''}`}>
                                            <div className="projects-container">
                                                {activeTab === 2 &&
                                                    <div className="display-projects">
                                                        <MyProjects ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 3 ? 'show active' : ''}`}>
                                            <div className="projects-container">
                                                {activeTab === 3 &&
                                                    <div className="display-projects">
                                                        <View24Crafts ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 5 ? 'show active' : ''}`}>
                                            <div className="projects-container">
                                                {activeTab === 5 &&
                                                    <div className="display-projects">
                                                        <ProfileVerification ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                        {/* <FormParser modelObject={Masters.Verified} formData={Data} formSubmit={formSubmit} error={Error} readOnly={readOnly} setReadOnly={setReadOnly} /> */}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 4 ? 'show active' : ''}`}>
                                            <div className="projects-container">
                                                {activeTab === 4 &&
                                                    <div className="display-projects">
                                                        <ProfileAuditions ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 6 ? 'show active' : ''}`}>
                                            <div className="projects-container">
                                                {activeTab === 6 &&
                                                    <div className="display-projects">
                                                        <PaymentHistory ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 7 ? 'show active' : ''}`}>
                                            <div className="projects-container">
                                                {activeTab === 7 &&
                                                    <div className="display-projects">
                                                        <ProfileShortlist ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 8 ? 'show active' : ''}`}>
                                            <div className="projects-container">
                                                {activeTab === 8 &&
                                                    <div className="display-projects">
                                                        <ProfileFollows ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 9 ? 'show active' : ''}`}>
                                            <div className="projects-container">
                                                {activeTab === 9 &&
                                                    <div className="display-projects">
                                                        <ProfileRequirement ProfileData={ProfileData} can_edit_profile={can_edit_profile} />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={`tab-pane fade ${activeTab === 10 ? 'show active' : ''}`}>
                                            {activeTab === 10 && <ProfileConsent ProfileData={ProfileData} />}
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    <div className="no-profile">
                                        <NavLink to="/24crafts">
                                            <button className="btn btn-default">Click Here to Create Profile</button>
                                        </NavLink>
                                    </div>
                                </>
                            }
                            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={EditProfileShow} onHide={handleEditProfileClose} className="edit-profile-popup">
                                <Modal.Header closeButton>
                                    <Modal.Title>Edit Profile</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <>
                                        {EditProfileFor === "dp" ?
                                            <EditDp ProfileData={ProfileData} handleLoginEvent={handleLoginEvent} />
                                            :
                                            <EditProfile ProfileData={ProfileData} handleLoginEvent={handleLoginEvent} />
                                        }
                                    </>
                                </Modal.Body>
                            </Modal>

                            <Modal
                                centered
                                show={showRevealMobileModal}
                                onHide={() => {
                                    if (!revealingMobile) setShowRevealMobileModal(false);
                                }}
                            >
                                <Modal.Header closeButton={!revealingMobile}>
                                    <Modal.Title>Reveal mobile number</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="mb-2">
                                        Mobile is audited when revealed. Please enter a reason.
                                    </div>
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        value={revealReason}
                                        disabled={revealingMobile}
                                        onChange={(e) => {
                                            setRevealReason(e.target.value);
                                            setRevealError("");
                                        }}
                                        placeholder="Required reason (e.g., 'Calling for audition schedule')"
                                    />
                                    {revealError && (
                                        <div className="text-danger mt-2">
                                            {revealError}
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        disabled={revealingMobile}
                                        onClick={() => setShowRevealMobileModal(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={revealingMobile}
                                        onClick={async () => {
                                            const reason = (revealReason || "").trim();
                                            if (!reason) {
                                                setRevealError("Reason is required to reveal the number.");
                                                return;
                                            }
                                            setRevealingMobile(true);
                                            try {
                                                await GetData({ reveal_mobile_number: 1, reveal_reason: reason });
                                                setShowRevealMobileModal(false);
                                            } catch (e) {
                                                setRevealError(
                                                    e?.response?.data?.detail ||
                                                    e?.response?.data?.error ||
                                                    "Failed to reveal mobile number."
                                                );
                                            } finally {
                                                setRevealingMobile(false);
                                            }
                                        }}
                                    >
                                        Reveal
                                    </button>
                                </Modal.Footer>
                            </Modal>
                            <Modal
                                centered
                                show={showDeleteModal}
                                onHide={() => {
                                    if (!deletingAccount) setShowDeleteModal(false);
                                }}
                            >
                                <Modal.Header closeButton={!deletingAccount}>
                                    <Modal.Title>Delete account</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="mb-2 text-muted small">
                                        {ProfileData.full_name} · HCC {ProfileData.hcc_id}
                                    </div>
                                    <p className="small text-danger mb-2">
                                        This permanently soft-deletes the account. The user cannot log in and will be hidden from all public views.
                                    </p>
                                    <label className="form-label"><b>Reason</b> (required)</label>
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        value={deleteReason}
                                        disabled={deletingAccount}
                                        onChange={(e) => {
                                            setDeleteReason(e.target.value);
                                            setDeleteError("");
                                        }}
                                        placeholder="e.g. Confirmed fraud — account terminated"
                                    />
                                    {deleteError && <div className="text-danger mt-2">{deleteError}</div>}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        disabled={deletingAccount}
                                        onClick={() => setShowDeleteModal(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        disabled={deletingAccount}
                                        onClick={confirmDeleteAccount}
                                    >
                                        {deletingAccount ? "Deleting..." : "Delete account"}
                                    </button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    )}
                </div>
            </div>

        </>
    )
}
export { ProfilePage }